import { UNACCEPTABLE_TYPES, UNWANTED_VALUES, PRIMITIVE_TYPES } from '../constants';
import jsonRedact from '../jsonRedact';

/**
 * Convert object to a string blob
 * @param  {Object} subject
 * @return {String}
 *
 * @example
 * blob({key: 'balue', attr: 'ibute'})
 * // Multiline output
 * key: balue
 * attr: ibute
 */
export default (subject) => Object
    .keys(subject)
    .filter((key) => filter(subject[key]))
    .map((key) => map(subject, key))
    .filter(Boolean)
    .join('\n');

/**
 * Map a key - value pair to a string (key: value)
 * @param  {object} subject
 * @param  {string} key
 * @return {string}
 */
function map(subject, key) {
    const value = simplify(subject[key]);

    return UNWANTED_VALUES.includes(value)
        ? ''
        : [key, value].join(': ')
    ;
}

/**
 * Filter function to filter out unwanted values and unacceptable types
 * @param  {any} value
 * @return {Boolean}
 */
function filter(value) {

    // Remove these falsy values completely
    if (UNWANTED_VALUES.includes(value)) {
        return false;
    }

    // Remove these types completely
    if (UNACCEPTABLE_TYPES.includes(typeof value)) {
        return false;
    }

    return true;
}

/**
 * Everything should become a string
 * @param  {any} value
 * @return {string|number|boolean}
 */
function simplify(value) {

    // Primitives continue as is
    if (PRIMITIVE_TYPES.includes(typeof value)) {
        return value;
    }

    // Array is joined to a string list
    if (Array.isArray(value)) {
        return value
            .filter(filter)
            .map(simplify)
            .filter(Boolean)
            .join(', ');
    }

    // Everything else becomes a string, one way or another
    try {
        return JSON.stringify(value, jsonRedact);
    } catch (error) {
        return `${value}`;
    }
}
